<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-6">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("bc_platform_connect") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

				<div class="col-lg-2 col-2 text-right">
					<base-input>
                                    <flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true, enableTime: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S' }"
                                        class="form-control datepicker"
                                        v-model="time_from"
                                    >
                                    </flat-picker>
                                </base-input>

								<!-- Time From -->
                </div>

				<div class="col-lg-2 col-2 text-right">
					<base-input>
						<flat-picker
                                        slot-scope="{ focus, blur }"
                                        @on-open="focus"
                                        @on-close="blur"
                                        :config="{ allowInput: true, enableTime: true, time_24hr: true, dateFormat: 'Y-m-d H:i:S' }"
                                        class="form-control datepicker"
                                        v-model="time_to"
                                    >
                                    </flat-picker>
					</base-input>
					<!-- Time To -->
				</div>

				<div class="col-lg-2 col-2 text-right">
					<base-button size="md" type="neutral" @click="handleSyncLog">
						<i class="fa fa-history mr-1"></i>{{ $t("sync.log.button") }}
					</base-button>
					<!-- Sync Log -->
				</div>
            </div>
        </base-header>
        <div class="container-fluid mt--6">
			<div class="row">
				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Tiktok</h5>
				  <div class="row">
					<div class="col-md-12">
						<img src="/img/tiktok.png" width="150px" height="150px">
					</div>
				  </div>

                    <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="TiktokSeller" label="Seller"  placeholder="Seller" value-key="id">
									<el-option v-for="option in tableTiktokeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('tiktok')"> Connect </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('tiktok')"> Token </base-button>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('tiktok')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('tiktok')"> Sync Product </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('tiktok')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('tiktok')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Lazada</h5>
				   <div class="row">
					<div class="col-md-12"> <img src="/img/lazada.png" width="150px" height="150px"> </div>
				  </div>

				  <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="LazadaSeller" label="Seller"  placeholder="Seller">
									<el-option v-for="option in tableLazadaSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                   <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('lazada')"> Connect </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('lazada')"> Token </base-button>
						</div>
					</div>

                   <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('lazada')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('lazada')"> Sync Product </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('lazada')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('lazada')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
                <card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
				  <h5 slot="header" class="h3 mb-0">Shopee</h5>
				  <div class="row">
					<div class="col-md-12">
						<img src="/img/shopee.png"  width="150px" height="150px">
					</div>
				  </div>

				  <div class="row mt-3 px-3">
                        <div class="col-md-12">
							<base-input placeholder="Seller">
								<el-select v-model="ShopeeSeller" label="Seller"  placeholder="Seller">
									<el-option v-for="option in tableShopeeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
								</el-select>
							</base-input>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon class="btn btn-icon" @click="handleConnect('shopee')"> Connect </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleRefreshToken('shopee')"> Token </base-button>
						</div>
					</div>

                    <div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('shopee')"> Sync Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('shopee')"> Sync Product </base-button>
						</div>
					</div>

					<div class="row mt-3">
                        <div class="col-md-12">
							<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('shopee')">Order </base-button>
							<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('shopee')">Product </base-button>
						</div>
					</div>
                </card>
				</div>

				<div class="col-xl-4 text-center">
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
					  <h5 slot="header" class="h3 mb-0">Line</h5>
					  <div class="row">
						<div class="col-md-12">
							<img src="/img/linemyshop.png"  width="150px" height="150px">
						</div>
					  </div>

					  <div class="row mt-3 px-3">
							<div class="col-md-12">
								<base-input placeholder="Seller">
									<el-select v-model="LineShopSeller" label="Seller"  placeholder="Seller">
										<el-option v-for="option in tableLineShopSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
									</el-select>
								</base-input>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('line')"> Sync Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('line')"> Sync Product </base-button>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('line')">Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('line')">Product </base-button>
							</div>
						</div>

					</card>
					</div>

				<div class="col-xl-4 text-center">
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
					  <h5 slot="header" class="h3 mb-0">Pancake</h5>
					  <div class="row">
						<div class="col-md-12">
							<img src="/img/pancake.webp"  width="150px" height="150px">
						</div>
					  </div>

					  <div class="row mt-3 px-3">
							<div class="col-md-12">
								<base-input placeholder="Seller">
									<el-select v-model="PancakeSeller" label="Seller"  placeholder="Seller">
										<el-option v-for="option in tablePancakeSeller" :key="option.open_id" :label="option.seller_name" :value="option" > </el-option>
									</el-select>
								</base-input>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleSyncOrder('pancake')"> Sync Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleSyncProduct('pancake')"> Sync Product </base-button>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('pancake')">Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('pancake')">Product </base-button>
							</div>
						</div>

					</card>
					</div>

				<!-- Makro PRO / Mirakl connect card (Dev A) -->
				<div class="col-xl-4 text-center">
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
					  <h5 slot="header" class="h3 mb-0">{{ $t('platform_integration.makro.title') }}</h5>
					  <div class="row">
						<div class="col-md-12">
							<img src="/img/makro.png" width="150px" height="150px" v-show="!makro.logoError" @error="makro.logoError = true">
						</div>
					  </div>

					  <!-- Credentials are config-only (config.yml platform.mirakl): no save
					       form. Show connection status + a test button. -->
					  <div class="row mt-3 px-3 text-left">
							<div class="col-md-12 mb-2">
								<span class="badge" :class="makro.configured ? 'badge-success' : 'badge-secondary'">
									{{ makro.configured ? $t('platform_integration.makro.configured') : $t('platform_integration.makro.not_configured') }}
								</span>
							</div>
							<div class="col-md-12" v-if="makro.configured">
								<p class="mb-1"><strong>{{ $t('platform_integration.makro.shop_name') }}:</strong> {{ makro.shop_name || makro.shop_id || '-' }}<span v-if="makro.shop_id"> ({{ makro.shop_id }})</span></p>
								<p class="mb-1"><strong>{{ $t('platform_integration.makro.instance_url') }}:</strong> {{ makro.instance_url || '-' }}</p>
								<p class="mb-1"><strong>{{ $t('platform_integration.makro.api_key') }}:</strong> {{ makro.api_key_masked || '-' }}</p>
							</div>
							<div class="col-md-12" v-else>
								<small class="text-muted">{{ $t('platform_integration.makro.credentialsConfigInfo') }}</small>
							</div>
						</div>

						<div class="row px-3" v-if="makro.test_result">
							<div class="col-md-12 mb-2">
								<span class="badge" :class="makro.test_ok ? 'badge-success' : 'badge-danger'">{{ makro.test_result }}</span>
							</div>
						</div>

						<div class="row mt-2">
							<div class="col-md-12">
								<base-button icon :loading="makro.testing" class="btn btn-icon" @click="handleMakroTest"> {{ $t('platform_integration.makro.test_connection') }} </base-button>
							</div>
						</div>

						<!-- Offer push — offers are the platform-10 product SKUs (maintained on
						     the product page). Push stock+price for the whole catalog, or push a
						     single offer (open/close a sale) by its SKU. -->
						<hr class="my-3" />
						<div class="row px-3 text-left">
							<div class="col-md-12 mb-2">
								<small class="text-muted">{{ $t('platform_integration.makro.offer_hint') }}</small>
							</div>
							<div class="col-md-12">
								<base-button block type="primary" :loading="makro.pushing" class="btn" @click="handleMakroPushOffers"> {{ $t('platform_integration.makro.push_offers') }} </base-button>
							</div>
							<div class="col-md-8 mt-2">
								<base-input :placeholder="$t('platform_integration.makro.offer_sku')" v-model="makro.offer_sku"></base-input>
							</div>
							<div class="col-md-4 mt-2">
								<base-button block type="secondary" :loading="makro.upserting" class="btn" @click="handleMakroUpsertOffer"> {{ $t('platform_integration.makro.push_offer') }} </base-button>
							</div>
						</div>

						<!-- Manual sync + view buttons (match the Pancake card). Makro has
						     no Seller select — the shop comes from config.yml — so the
						     Sync handlers skip all seller fields. Sync needs the card to
						     be configured; the Order/Product view buttons are always on. -->
						<hr class="my-3" />
						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" :disabled="!makro.configured" class="btn btn-icon" @click="handleSyncOrder('makro')"> Sync Order </base-button>
								<base-button icon :loading="productLoading" :disabled="!makro.configured" class="btn btn-icon" @click="handleSyncProduct('makro')"> Sync Product </base-button>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" class="btn btn-icon" @click="handleOrder('makro')">Order </base-button>
								<base-button icon :loading="productLoading" class="btn btn-icon" @click="handleProduct('makro')">Product </base-button>
							</div>
						</div>

					</card>
					</div>

				<!-- Amaze (amaze-x) connect card — Phase 0 -->
				<div class="col-xl-4 text-center">
					<card class="no-border-card" body-classes="px-0 pb-1" footer-classes="pb-2">
					  <h5 slot="header" class="h3 mb-0">{{ $t('platform_integration.amaze.title') }}</h5>
					  <div class="row">
						<div class="col-md-12">
							<!-- /img/amaze.png is not shipped yet — fall back to a text
							     placeholder so the card never renders a broken image. -->
							<img src="/img/amaze.png" width="150px" height="150px" v-show="!amaze.logoError" @error="amaze.logoError = true">
							<div v-if="amaze.logoError" class="d-flex align-items-center justify-content-center text-muted" style="height:150px">
								<h3 class="mb-0">{{ $t('platform_integration.amaze.title') }}</h3>
							</div>
						</div>
					  </div>

					  <!-- Credentials are config-only (config.yml platform.amaze): there is
					       no save form, the card is read-only status + a test button. -->
					  <div class="row mt-3 px-3 text-left">
							<div class="col-md-12 mb-2">
								<span class="badge" :class="amaze.configured ? 'badge-success' : 'badge-secondary'">
									{{ amaze.configured ? $t('platform_integration.amaze.configured') : $t('platform_integration.amaze.not_configured') }}
								</span>
							</div>
							<div class="col-md-12" v-if="amaze.configured">
								<p class="mb-1">
									<strong>{{ $t('platform_integration.amaze.shop_name') }}:</strong>
									{{ amaze.shop_name || '-' }}<span v-if="amaze.amaze_id" :title="$t('platform_integration.amaze.amaze_id')"> ({{ amaze.amaze_id }})</span>
								</p>
								<p class="mb-1"><strong>{{ $t('platform_integration.amaze.env') }}:</strong> {{ amazeEnvLabel }}</p>
								<p class="mb-1"><strong>{{ $t('platform_integration.amaze.account') }}:</strong> {{ amaze.username_masked || '-' }}</p>
							</div>
							<div class="col-md-12">
								<small class="text-muted">{{ $t('platform_integration.amaze.credentialsConfigInfo') }}</small>
							</div>
						</div>

						<!-- Test result: shop name + detected date format + the rate-limit
						     ceiling OF THIS CONTAINER (not the shared budget). -->
						<div class="row px-3 mt-2 text-left" v-if="amaze.test_result">
							<div class="col-md-12 mb-1">
								<span class="badge" :class="amaze.test_ok ? 'badge-success' : 'badge-danger'">{{ amaze.test_result }}</span>
							</div>
							<div class="col-md-12" v-if="amaze.test_ok && amaze.date_format_detected">
								<small>{{ $t('platform_integration.amaze.date_format_detected', { format: amaze.date_format_detected }) }}</small>
							</div>
						</div>

						<div class="row px-3 text-left" v-if="amaze.rate_limit_rps">
							<div class="col-md-12">
								<small>{{ $t('platform_integration.amaze.rate_limit', { rps: amaze.rate_limit_rps }) }}</small><br />
								<small class="text-muted">{{ $t('platform_integration.amaze.rate_limit_hint') }}</small>
							</div>
						</div>

						<!-- Poller status (endpoint /amaze/health). The pollers live in the
						     Webhook container, so this row is the only signal the BO screen
						     has that order/product polling is still alive. -->
						<div class="row px-3 mt-2 text-left">
							<div class="col-md-12">
								<small :class="amazeOrderPollStale ? 'text-danger' : 'text-muted'">
									{{ $t('platform_integration.amaze.last_order_poll', { time: amazeLastOrderPollLabel }) }}
								</small><br />
								<small :class="amazeProductPollStale ? 'text-danger' : 'text-muted'">
									{{ $t('platform_integration.amaze.last_product_poll', { time: amazeLastProductPollLabel }) }}
								</small>
								<p v-if="amazeOrderPollStale || amazeProductPollStale" class="mb-0">
									<small class="text-danger">{{ $t('platform_integration.amaze.poller_stalled') }}</small>
								</p>
							</div>
						</div>

						<hr class="my-3" />
						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="amaze.testing" class="btn btn-icon" @click="handleAmazeTest"> {{ $t('platform_integration.amaze.test_connection') }} </base-button>
							</div>
						</div>

						<div class="row mt-3">
							<div class="col-md-12">
								<base-button icon :loading="orderLoading" :disabled="!amaze.configured" class="btn btn-icon" @click="handleSyncOrder('amaze')"> {{ $t('platform_integration.amaze.sync_order') }} </base-button>
								<base-button icon :loading="productLoading" :disabled="!amaze.configured" class="btn btn-icon" @click="handleSyncProduct('amaze')"> {{ $t('platform_integration.amaze.sync_product') }} </base-button>
							</div>
						</div>

					</card>
					</div>
			</div>
        </div>

        <!-- Sync progress modal (Issue #32) — no redirect; opt-in view buttons -->
        <el-dialog
            :title="syncModalTitle"
            :visible.sync="syncModalVisible"
            width="420px"
            :close-on-click-modal="false"
            @close="onSyncModalClose"
        >
            <div class="sync-modal-body">
                <el-progress
                    :percentage="syncPercent"
                    :status="syncProgressStatus"
                    :indeterminate="syncIndeterminate"
                    :stroke-width="16"
                ></el-progress>

                <div class="mt-3">
                    <span class="badge" :class="syncBadgeClass">
                        {{ $t('sync.modal.status.' + (syncJob.status || 'queued')) }}
                    </span>
                </div>

                <p class="mt-2 mb-0">
                    <template v-if="syncJob.total > 0">
                        {{ $t('sync.modal.progress', { done: syncJob.done, total: syncJob.total }) }}
                    </template>
                    <template v-else>
                        {{ $t('sync.modal.progress_indeterminate', { done: syncJob.done }) }}
                    </template>
                </p>

                <p v-if="syncJob.failed > 0" class="text-danger mb-0">
                    {{ $t('sync.modal.failed_count', { failed: syncJob.failed }) }}
                </p>

                <p v-if="syncJob.status === 'failed' && syncJob.error" class="text-danger mt-2 mb-0">
                    {{ syncJob.error }}
                </p>
            </div>

            <span slot="footer" class="dialog-footer">
                <base-button
                    v-if="syncJob.status === 'done' || syncJob.status === 'failed'"
                    type="primary"
                    class="btn btn-sm"
                    @click="handleViewSyncResult"
                >
                    {{ syncJob.type === 'product' ? $t('sync.modal.view_products') : $t('sync.modal.view_orders') }}
                </base-button>
                <base-button class="btn btn-sm" @click="closeSyncModal">
                    {{ $t('sync.modal.close') }}
                </base-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Dialog, Progress } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "./PaginatedTables/TiktokclientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moment from 'moment'
import { PlatformMiraklService, PlatformAmazeService, OrderService } from "@/resource";
import { platformErrorCode, platformErrorText } from "@/util/platform-error";

// Fallback poller cadence (minutes) used only to decide "is this stale?" when
// the health endpoint does not report the intervals. Matches the documented
// defaults of service_webhook.amaze.{order_sync,product_sync}.interval.
const AMAZE_DEFAULT_ORDER_POLL_MINUTES = 3;
const AMAZE_DEFAULT_PRODUCT_POLL_MINUTES = 360;
// A poll older than this many intervals is treated as "the poller is dead".
const AMAZE_STALE_FACTOR = 3;

export default {
    mixins: [clientPaginationMixin],
    components: {
        flatPicker,
        BasePagination,
        RouteBreadCrumb,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Dialog.name]: Dialog,
        [Progress.name]: Progress
    },
    computed: {
        ...mapGetters({
            // tableData: "Tiktok/getOrders",
            tableSeller: "Platform/getSellers"
        }),
		tableTiktokeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 2
			})
		},
		tableLazadaSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 4
			})
		},
		tableShopeeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 3
			})
		},
		tableLineShopSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 5
			})
		},
		tablePancakeSeller : function(){
			return this.tableSeller.filter(e => {
				return e.platform_id == 8
			})
		},
        tableColumns: function() {
            return [
                {
                    prop: "ProductName",
                    label: this.$t("wms.product"),
                    minWidth: 90,
                    sortable: true
                },

                {
                    prop: "StorageName",
                    label: this.$t("wms.storage"),
                    minWidth: 100,
                    sortable: true
                },
                {
                    prop: "Balance",
                    label: this.$t("wms.balance"),
                    minWidth: 120,
                    sortable: true
                },
                {
                    prop: "OverallAmount",
                    label: this.$t("wms.overall_amount"),
                    minWidth: 90,
                    sortable: true
                }
            ];
        },
        // --- Sync progress modal (Issue #32) ---
        syncModalTitle: function() {
            var platform = this.syncJob.platform || this.syncJobPlatform || "";
            var key = this.syncJob.type === "product"
                ? "sync.modal.title_product"
                : "sync.modal.title_order";
            return this.$t(key, { platform: platform });
        },
        syncPercent: function() {
            if (this.syncJob.total > 0) {
                var pct = Math.round((this.syncJob.done / this.syncJob.total) * 100);
                if (pct > 100) pct = 100;
                if (pct < 0) pct = 0;
                return pct;
            }
            // Unknown total: full bar on done/failed, otherwise 0 (indeterminate).
            if (this.syncJob.status === "done") return 100;
            return 0;
        },
        syncIndeterminate: function() {
            return this.syncJob.total === 0 &&
                (this.syncJob.status === "running" || this.syncJob.status === "queued");
        },
        syncProgressStatus: function() {
            if (this.syncJob.status === "done") return "success";
            if (this.syncJob.status === "failed") return "exception";
            return null;
        },
        syncBadgeClass: function() {
            switch (this.syncJob.status) {
                case "done": return "badge-success";
                case "failed": return "badge-danger";
                case "running": return "badge-info";
                default: return "badge-secondary";
            }
        },
        // --- Amaze card ---
        amazeEnvLabel: function() {
            var env = (this.amaze.env || "").toLowerCase();
            if (env === "prod" || env === "production") return this.$t("platform_integration.amaze.env_prod");
            if (env === "uat") return this.$t("platform_integration.amaze.env_uat");
            return this.amaze.env || "-";
        },
        amazeLastOrderPollLabel: function() {
            return this.amazePollLabel(this.amaze.last_order_poll_at, this.amazeNow);
        },
        amazeLastProductPollLabel: function() {
            return this.amazePollLabel(this.amaze.last_product_poll_at, this.amazeNow);
        },
        // Red when the last poll is older than 3x its interval — the poller runs
        // in another container, so a stalled heartbeat is the only symptom the
        // BO screen can show.
        amazeOrderPollStale: function() {
            return this.amazePollStale(
                this.amaze.last_order_poll_at,
                this.amaze.order_poll_interval || AMAZE_DEFAULT_ORDER_POLL_MINUTES,
                this.amazeNow
            );
        },
        amazeProductPollStale: function() {
            return this.amazePollStale(
                this.amaze.last_product_poll_at,
                this.amaze.product_poll_interval || AMAZE_DEFAULT_PRODUCT_POLL_MINUTES,
                this.amazeNow
            );
        }
    },
    data() {
        return {
			time_from: "",
			time_to: "",
            propsToSearch: ["Number", "Email"],
			productLoading:false,
			orderLoading:false,
			// Sync progress modal (Issue #32)
			syncModalVisible: false,
			syncJobPlatform: "",
			syncJob: {
				job_id: 0,
				platform: "",
				type: "",
				status: "queued",
				total: 0,
				done: 0,
				failed: 0,
				error: "",
			},
			pollTimer: null,
            selectedRows: [],
            SearchKeyword: "",
            showAddModal: false,
            showInOutModal: false,
            status: 0,
            startDate: "",
            endDate: "",
			TiktokSeller:null,
			LazadaSeller:null,
			ShopeeSeller:null,
			LineShopSeller:null,
			PancakeSeller:null,
			// Makro PRO / Mirakl connect card. Credentials are config-only
			// (config.yml platform.mirakl); the card is read-only status + test.
			makro: {
				instance_url: "",
				shop_id: "",
				shop_name: "",
				api_key_masked: "",
				configured: false,
				testing: false,
				test_ok: false,
				test_result: "",
				logoError: false,
				pushing: false,
				upserting: false,
				offer_sku: "",
			},
			// Amaze (amaze-x) connect card. Credentials are config-only
			// (config.yml platform.amaze) — read-only status + test + sync.
			amaze: {
				configured: false,
				env: "",
				shop_id: "",
				amaze_id: "",
				shop_name: "",
				username_masked: "",
				testing: false,
				test_ok: false,
				test_result: "",
				date_format_detected: "",
				rate_limit_rps: 0,
				logoError: false,
				// poller health (endpoint /amaze/health)
				health_loaded: false,
				last_order_poll_at: "",
				last_product_poll_at: "",
				order_poll_interval: 0,
				product_poll_interval: 0,
			},
			// Ticks with the health timer so the "x minutes ago" labels and the
			// stale flags keep moving while the page stays open.
			amazeNow: Date.now(),
			amazeHealthTimer: null,
            md: {
                InventoryID: 0,
                ProductID: "-",
                StorageID: "-",
                Note: "",
                Quantity: "0",
                Cost: 0
            },
            inOut: {
                InventoryID: 0,
                ProductID: 0,
                StorageID: 0,
                Note: "",
                Quantity: 0,
                Cost: 0,
                Action: ""
            },
            rowEdit: {
                ID: 0,
                Number: ""
            },

            OrderStatus: [
                { ID: 0, Name: "All" },
                { ID: 100, Name: "Unpaid" },
                { ID: 111, Name: "AwaitingShipment" },
                { ID: 112, Name: "AwaitingCollection" },
                { ID: 114, Name: "PartiallyShipping" },
                { ID: 121, Name: "InTransit" },
                { ID: 122, Name: "Delivered" },
                { ID: 130, Name: "Completed" },
                { ID: 140, Name: "Cancelled" }
            ],
			PlatformTable: [
				{id:1,name:"madamefin"},
				{id:2,name:"tiktok"},
				{id:3,name:"shopee"},
				{id:4,name:"lazada"},
				{id:5,name:"line"},
				{id:6,name:"pancake"},

			]
        };
    },
    watch: {
		time_from() {
			this.validateDateRange();
		},
		time_to() {
			this.validateDateRange();
		}
	},
    mounted() {
		this.time_from = moment().format('YYYY-MM-DD 00:00:00');
		this.time_to = moment().format('YYYY-MM-DD 23:59:59');
		this.SellerList()
		this.loadMakroCredentials()
		this.loadAmazeCredentials()
		this.loadAmazeSettings()
		this.loadAmazeHealth()
		this.startAmazeHealthTimer()

	},
    methods: {
        ...mapActions({
            // InventoryIn: "Inventory/InventoryIn",
            // InventoryOut: "Inventory/InventoryOut",
            // InventoryDelete: "Inventory/InventoryDelete",
            // listData: "Tiktok/GetOrderList",
            // getShippingDocument: "Tiktok/GetShippingDocument",
            syncProduct: "Platform/SyncProduct",
            syncOrder: "Platform/SyncOrder",
            syncProductV2: "Platform/SyncProductV2",
            syncOrderV2: "Platform/SyncOrderV2",
            getSyncJob: "Platform/GetSyncJob",
            ConnectPlatform: "Platform/ConnectPlatform",
            SellerList: "Platform/listSeller",
			RefreshToken: "Platform/RefreshToken",
			MiraklGetCredentials: "Platform/MiraklGetCredentials",
			MiraklTestConnection: "Platform/MiraklTestConnection",
			setPlatformCurrentParams: "Product/setPlatformCurrentParams",
        }),
		// --- Makro PRO / Mirakl connect (credentials are config-only) ---
		async loadMakroCredentials() {
			try {
				const res = await this.MiraklGetCredentials();
				const d = (res && res.data && res.data.Datum) ? res.data.Datum : {};
				this.makro.instance_url = d.instance_url || "";
				this.makro.shop_id = d.shop_id || "";
				this.makro.shop_name = d.shop_name || "";
				this.makro.api_key_masked = d.api_key_masked || "";
				this.makro.configured = !!d.configured;
			} catch (err) {
				// silent — card simply shows "not configured"
			}
		},
		async handleMakroTest() {
			this.makro.testing = true;
			this.makro.test_result = "";
			try {
				// Credentials come from config.yml — no body to send.
				const res = await this.MiraklTestConnection();
				const d = (res && res.data && res.data.Datum) ? res.data.Datum : {};
				this.makro.test_ok = true;
				this.makro.test_result = this.$t('platform_integration.makro.test_ok', { shop: d.shop_name || this.makro.shop_name || "" });
			} catch (err) {
				this.makro.test_ok = false;
				const msg = (err && err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : (err && err.message) ? err.message : "";
				this.makro.test_result = this.$t('platform_integration.makro.test_fail', { reason: msg });
			} finally {
				this.makro.testing = false;
			}
		},
		// Push stock + price (STO01 + PRI01) for the whole platform-10 catalog.
		// Reuses the shared Sync progress modal + poller.
		async handleMakroPushOffers() {
			this.makro.pushing = true;
			try {
				const res = await PlatformMiraklService.offersPush({});
				this.openSyncModal("makro", "product", (res && res.data) ? res.data : {});
			} catch (err) {
				if (err && err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
					this.openSyncModal("makro", "product", err.response.data);
					return;
				}
				const msg = (err && err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : (err && err.message) ? err.message : "";
				swal.fire({ title: this.$t('platform_integration.makro.push_fail'), text: msg, icon: "error", confirmButtonClass: "btn btn-danger btn-fill", buttonsStyling: false });
			} finally {
				this.makro.pushing = false;
			}
		},
		// Push a single offer via OF24 (open/close a sale) by its offer SKU.
		async handleMakroUpsertOffer() {
			const sku = (this.makro.offer_sku || "").trim();
			if (!sku) {
				swal.fire({ title: this.$t('platform_integration.makro.offer_sku_required'), icon: "warning", confirmButtonClass: "btn btn-warning btn-fill", buttonsStyling: false });
				return;
			}
			this.makro.upserting = true;
			try {
				await PlatformMiraklService.offerUpsertOne({ offer_sku: sku });
				swal.fire({ title: this.$t('platform_integration.makro.push_offer_ok'), icon: "success", confirmButtonClass: "btn btn-success btn-fill", buttonsStyling: false });
			} catch (err) {
				const msg = (err && err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : (err && err.message) ? err.message : "";
				swal.fire({ title: this.$t('platform_integration.makro.push_offer_fail'), text: msg, icon: "error", confirmButtonClass: "btn btn-danger btn-fill", buttonsStyling: false });
			} finally {
				this.makro.upserting = false;
			}
		},
		// --- Amaze (amaze-x) connect card ---
		// BE wraps most payloads in the r.OK envelope (data.Datum); the sync
		// endpoints answer with a bare body. Read both shapes defensively.
		amazeDatum(res) {
			if (!res || !res.data) return {};
			return res.data.Datum ? res.data.Datum : res.data;
		},
		async loadAmazeCredentials() {
			try {
				const d = this.amazeDatum(await PlatformAmazeService.getCredentials());
				this.amaze.configured = !!d.configured;
				this.amaze.env = d.env || "";
				this.amaze.shop_id = d.shop_id || "";
				this.amaze.amaze_id = d.amaze_id || "";
				this.amaze.shop_name = d.shop_name || "";
				this.amaze.username_masked = d.username_masked || "";
			} catch (err) {
				// silent — card simply shows "not configured"
			}
		},
		// Settings of the Backoffice container only. Used for the rate-limit
		// line so the ceiling is visible before anyone presses Test.
		async loadAmazeSettings() {
			try {
				const d = this.amazeDatum(await PlatformAmazeService.getSettings());
				if (d.rate_limit_rps) this.amaze.rate_limit_rps = d.rate_limit_rps;
			} catch (err) {
				// silent — the rate-limit line is simply hidden
			}
		},
		async loadAmazeHealth() {
			try {
				const d = this.amazeDatum(await PlatformAmazeService.pollerStatus());
				this.amaze.last_order_poll_at = d.last_order_poll_at || "";
				this.amaze.last_product_poll_at = d.last_product_poll_at || "";
				this.amaze.order_poll_interval = Number(d.order_poll_interval_minutes) || 0;
				this.amaze.product_poll_interval = Number(d.product_poll_interval_minutes) || 0;
				if (d.rate_limit_rps) this.amaze.rate_limit_rps = d.rate_limit_rps;
				this.amaze.health_loaded = true;
			} catch (err) {
				// Health is unavailable (endpoint missing / no permission): show
				// "unknown" instead of a fake timestamp, and stop the timer so we
				// do not hammer a failing endpoint every minute.
				this.amaze.health_loaded = false;
				this.stopAmazeHealthTimer();
			}
		},
		startAmazeHealthTimer(){
			this.stopAmazeHealthTimer();
			this.amazeHealthTimer = setInterval(() => {
				this.amazeNow = Date.now();
				this.loadAmazeHealth();
			}, 60000);
		},
		stopAmazeHealthTimer(){
			if (this.amazeHealthTimer) {
				clearInterval(this.amazeHealthTimer);
				this.amazeHealthTimer = null;
			}
		},
		amazePollLabel(value, now){
			if (!this.amaze.health_loaded) return this.$t("platform_integration.amaze.poller_unknown");
			if (!value) return this.$t("platform_integration.amaze.poller_never");
			const m = moment(value);
			if (!m.isValid()) return this.$t("platform_integration.amaze.poller_unknown");
			return m.format("YYYY-MM-DD HH:mm:ss") + " (" + m.from(moment(now)) + ")";
		},
		amazePollStale(value, intervalMinutes, now){
			// Not configured = nothing is supposed to be polling: never warn.
			if (!this.amaze.configured) return false;
			if (!this.amaze.health_loaded) return false;
			if (!value) return true;
			const m = moment(value);
			if (!m.isValid()) return true;
			const limit = AMAZE_STALE_FACTOR * intervalMinutes * 60 * 1000;
			return moment(now).diff(m) > limit;
		},
		async handleAmazeTest() {
			this.amaze.testing = true;
			this.amaze.test_result = "";
			try {
				// Credentials come from config.yml — no body to send.
				const d = this.amazeDatum(await PlatformAmazeService.testConnection());
				this.amaze.test_ok = true;
				this.amaze.date_format_detected = d.date_format_detected || "";
				if (d.rate_limit_rps) this.amaze.rate_limit_rps = d.rate_limit_rps;
				if (d.shop_name) this.amaze.shop_name = d.shop_name;
				if (d.amaze_id) this.amaze.amaze_id = d.amaze_id;
				this.amaze.test_result = this.$t('platform_integration.amaze.test_ok', { shop: d.shop_name || this.amaze.shop_name || "" });
			} catch (err) {
				this.amaze.test_ok = false;
				this.amaze.date_format_detected = "";
				const msg = (err && err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : (err && err.message) ? err.message : "";
				this.amaze.test_result = this.$t('platform_integration.amaze.test_fail', { reason: msg });
			} finally {
				this.amaze.testing = false;
			}
		},
		validateDateRange() {
			if (!this.time_from || !this.time_to) return true;
			
			const fromDate = moment(this.time_from, 'YYYY-MM-DD HH:mm:ss');
			const toDate = moment(this.time_to, 'YYYY-MM-DD HH:mm:ss');
			
			if (fromDate.isAfter(toDate)) {
				swal.fire({
					title: "เวลาเริ่มต้นต้องน้อยกว่าเวลาสิ้นสุด",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return false;
			}
			
			const daysDiff = toDate.diff(fromDate, 'days', true);
			if (daysDiff > 2) {
				swal.fire({
					title: "ช่วงเวลาต้องไม่เกิน 2 วัน",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return false;
			}
			
			return true;
		},
		GetPlatformID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
					console.log(v.name)
				if (v.name == platform)
				{
					platform_id = v.id
				}
			})

			return platform_id
		},

		handleOrder(platform){
				this.$router.push({ path: `/backoffice/orders?platform=${platform}` });
		},
		handleSyncLog(){
				this.$router.push('/admin/platform/sync-logs');
		},
		handleProduct(platform){
				// Makro (platform 10) products live in productv2 as shadow offer
				// SKUs — there is no per-platform product list page for it.
				if (platform === "makro") {
					this.goMakroProductsV2();
					return;
				}
				this.$router.push({ path: `/admin/product/${platform}` });

		},
		// Preselect Makro (platform 10, no shop) on productv2 via the shared
		// Product store params — the same mechanism productv2's getParam()
		// consumes on mount.
		goMakroProductsV2(){
				this.setPlatformCurrentParams({
					status: 0,
					mappingStatus: 2,
					currentPage: 1,
					platform_id: 10,
					platform_shop_id: 0,
					keyword: "",
				});
				this.$router.push({ path: `/admin/product_platform` });
		},

		handleSyncOrder(platform){
			if (!this.validateDateRange()) {
				return;
			}

			// Makro PRO (Mirakl) has its own dedicated sync endpoint — not the
			// generic marketplace SyncOrderV2 (no seller/open_id/shop fields;
			// the BE reads the shop from config.yml). Route it separately.
			if (platform === "makro") {
				this.orderLoading = true
				OrderService.miraklSyncOrders({
					time_from: this.time_from,
					time_to: this.time_to,
				}).then(resp=>{
					this.orderLoading = false
					this.openSyncModal(platform, "order", resp && resp.data ? resp.data : {});
				}).catch(err=>{
					console.log("error",err)
					this.orderLoading = false
					// 422 busy still carries an in-flight job_id we can attach to.
					if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
						this.openSyncModal(platform, "order", err.response.data);
						return;
					}
					swal.fire({
                        title: this.busyOrErrorTitle(err),
                        text: "",
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
				})
				return;
			}

			// Amaze has its own endpoint too (no seller/shop fields — the shop
			// comes from config.yml). Same 422 = already-in-flight contract.
			if (platform === "amaze") {
				this.orderLoading = true
				PlatformAmazeService.ordersSync({
					time_from: this.time_from,
					time_to: this.time_to,
				}).then(resp=>{
					this.orderLoading = false
					this.openSyncModal(platform, "order", resp && resp.data ? resp.data : {});
				}).catch(err=>{
					this.orderLoading = false
					if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
						this.openSyncModal(platform, "order", err.response.data);
						return;
					}
					swal.fire({
                        title: this.busyOrErrorTitle(err),
                        text: "",
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
				})
				return;
			}

			let params = {
				platform : platform,
				open_id : "",
				shop_id : "",
				shop_name : "",
                time_from : this.time_from,
                time_to : this.time_to,
			}

			try {
				switch (platform)  {
					case "tiktok" :
					 	params.open_id = this.TiktokSeller.open_id;
					 	params.shop_id = this.TiktokSeller.shop_id;
					 	params.shop_name = this.TiktokSeller.shop_name;
					 	params.shop_cipher = this.TiktokSeller.shop_cipher;

					break
					case "shopee" :
						params.open_id = this.ShopeeSeller.open_id;
					 	params.shop_id = this.ShopeeSeller.shop_id;
					 	params.shop_name = this.ShopeeSeller.shop_name;
					 	params.shop_cipher = this.ShopeeSeller.shop_cipher;
					break
					case "lazada" :
						params.open_id = this.LazadaSeller.open_id;
					 	params.shop_id = this.LazadaSeller.shop_id;
					 	params.shop_name = this.LazadaSeller.shop_name;
					 	params.shop_cipher = this.LazadaSeller.shop_cipher;
						break
					case "line" :
						params.open_id = this.LineShopSeller.open_id;
					 	params.shop_id = this.LineShopSeller.shop_id;
					 	params.shop_name = this.LineShopSeller.shop_name;
					 	params.shop_cipher = this.LineShopSeller.shop_cipher;
						break
					case "pancake" :
						params.open_id = this.PancakeSeller.open_id;
					 	params.shop_id = this.PancakeSeller.shop_id;
					 	params.shop_name = this.PancakeSeller.shop_name;
					 	params.shop_cipher = this.PancakeSeller.shop_cipher;
						break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return

			}

			this.orderLoading = true
			this.syncOrderV2(params).then(resp=>{
				// No redirect (Issue #32): open the progress modal and poll.
				this.orderLoading = false
				this.openSyncModal(platform, "order", resp && resp.data ? resp.data : {});
			}).catch(err=>{
				console.log("error",err)
				this.orderLoading = false
				// 422 busy still carries an in-flight job_id we can attach to.
				if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
					this.openSyncModal(platform, "order", err.response.data);
					return;
				}
				swal.fire({
                    title: this.busyOrErrorTitle(err),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			})
		},
		handleRefreshToken(platform){
			let params = {
				platform : platform,
				shop_id : "",
				shop_cipher : "",
				shop_name : ""	
			}

			try {
				switch (platform)  {
					case "tiktok" : params.shop_id = this.TiktokSeller.shop_id; params.shop_cipher = this.TiktokSeller.shop_cipher; params.shop_name = this.TiktokSeller.shop_name; break
					case "shopee" : params.shop_id = this.ShopeeSeller.shop_id; params.shop_cipher = this.ShopeeSeller.shop_cipher; params.shop_name = this.ShopeeSeller.shop_name; break
					case "lazada" :params.shop_id = this.LazadaSeller.shop_id; params.shop_cipher = this.LazadaSeller.shop_cipher; params.shop_name = this.LazadaSeller.shop_name; break
					case "pancake" :params.shop_id = this.PancakeSeller.shop_id; params.shop_cipher = this.PancakeSeller.shop_cipher; params.shop_name = this.PancakeSeller.shop_name; break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return
			}

			if (params.shop_id == "") {
				swal.fire({
					title: "กรุณาเลือก Seller",
					text: "",
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
				return
			}

			this.RefreshToken(params).then(resp=>{
				swal.fire({
					title: "Refresh Token Success",
					text: "",
					icon: "success",
					confirmButtonClass: "btn btn-primary btn-fill",
					buttonsStyling: false
				});


			}).catch(err=>{
				swal.fire({
                    title: this.$t(err.response.data.Msg),
                    text: err,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			});

		},
		handleSyncProduct(platform){

			// Makro PRO (Mirakl) has its own dedicated sync endpoint — not the
			// generic marketplace SyncProductV2 (no seller/shop fields; the BE
			// reads the shop from config.yml, and the request body is empty).
			if (platform === "makro") {
				this.productLoading = true
				PlatformMiraklService.productsSync().then(resp=>{
					this.productLoading = false
					this.openSyncModal(platform, "product", resp && resp.data ? resp.data : {});
				}).catch(err=>{
					this.productLoading = false
					if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
						this.openSyncModal(platform, "product", err.response.data);
						return;
					}
					swal.fire({
                        title: this.busyOrErrorTitle(err),
                        text: "",
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
				});
				return;
			}

			// Amaze catalogue sync — empty body, shop from config.yml.
			if (platform === "amaze") {
				this.productLoading = true
				PlatformAmazeService.productsSync().then(resp=>{
					this.productLoading = false
					this.openSyncModal(platform, "product", resp && resp.data ? resp.data : {});
				}).catch(err=>{
					this.productLoading = false
					if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
						this.openSyncModal(platform, "product", err.response.data);
						return;
					}
					swal.fire({
                        title: this.busyOrErrorTitle(err),
                        text: "",
                        icon: "error",
                        confirmButtonClass: "btn btn-danger btn-fill",
                        buttonsStyling: false
                    });
				});
				return;
			}

			let params = {
				platform : platform,
				shop_id : "",
				shop_cipher : "",
				shop_name : "",
			}

			try {
				switch (platform)  {
					case "tiktok" : params.shop_id = this.TiktokSeller.shop_id; params.shop_cipher = this.TiktokSeller.shop_cipher; params.shop_name = this.TiktokSeller.shop_name; break
					case "shopee" : params.shop_id = this.ShopeeSeller.shop_id; params.shop_cipher = this.ShopeeSeller.shop_cipher; params.shop_name = this.ShopeeSeller.shop_name; break
					case "lazada" :params.shop_id = this.LazadaSeller.shop_id; params.shop_cipher = this.LazadaSeller.shop_cipher; params.shop_name = this.LazadaSeller.shop_name; break
					case "line" :params.shop_id = this.LineShopSeller.shop_id; params.shop_cipher = this.LineShopSeller.shop_cipher; params.shop_name = this.LineShopSeller.shop_name; break
					case "pancake" :params.shop_id = this.PancakeSeller.shop_id; params.shop_cipher = this.PancakeSeller.shop_cipher; params.shop_name = this.PancakeSeller.shop_name; break
				}
			}
			catch (err){
				console.log(err)
				swal.fire({
                    title: "กรุณาเลือก Seller",
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
				return

			}

			console.log("params",params)

			this.productLoading = true
			this.syncProductV2(params).then(resp=>{
				// No redirect (Issue #32): open the progress modal and poll.
				this.productLoading = false
				this.openSyncModal(platform, "product", resp && resp.data ? resp.data : {});
			}).catch(err=>{
				this.productLoading = false
				if (err.response && err.response.status === 422 && err.response.data && err.response.data.job_id) {
					this.openSyncModal(platform, "product", err.response.data);
					return;
				}
				swal.fire({
                    title: this.busyOrErrorTitle(err),
                    text: "",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
			});
		},
		handleConnect(platform){
			let id = this.GetPlatformID(platform)
			this.ConnectPlatform(id).then(resp=>{
				window.open(resp.data)
			}).catch(err=>{
				console.log(err)
				swal.fire({
                    title: "Can't connect platform",
                    text: err.respone,
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
				})
			})

		},

		// --- Sync progress modal (Issue #32) ---
		busyOrErrorTitle(err){
			// 422 busy without a job_id -> friendly "already running" message.
			if (err && err.response && err.response.status === 422) {
				return this.$t("sync.modal.busy");
			}
			// 424 / 503 platform_*: the shop's token is unusable (reconnect it)
			// or the integration is off — print the server's own sentence.
			if (platformErrorCode(err)) {
				return platformErrorText(err, this.$i18n && this.$i18n.locale);
			}
			if (err && err.response && err.response.data) {
				let d = err.response.data;
				if (typeof d === "string") return this.$t(d);
				if (d.Msg) return this.$t(d.Msg);
				if (d.message) return d.message;
			}
			return this.$t("sync.modal.status.failed");
		},
		openSyncModal(platform, type, data){
			this.stopPolling();
			data = data || {};
			this.syncJobPlatform = platform;
			this.syncJob = {
				job_id: data.job_id || 0,
				platform: data.platform || platform,
				type: data.type || type,
				status: data.status || "queued",
				total: data.total || 0,
				done: data.done || 0,
				failed: data.failed || 0,
				error: data.error || "",
			};
			this.syncModalVisible = true;

			if (!this.syncJob.job_id) {
				// No job id (e.g. line/pancake legacy path): show queued, nothing to poll.
				return;
			}
			this.startPolling();
		},
		startPolling(){
			this.stopPolling();
			// Poll immediately, then every 2s until done/failed.
			this.pollSyncJob();
			this.pollTimer = setInterval(this.pollSyncJob, 2000);
		},
		stopPolling(){
			if (this.pollTimer) {
				clearInterval(this.pollTimer);
				this.pollTimer = null;
			}
		},
		pollSyncJob(){
			if (!this.syncJob.job_id) {
				this.stopPolling();
				return;
			}
			this.getSyncJob(this.syncJob.job_id).then(resp=>{
				let d = resp && resp.data ? resp.data : {};
				this.syncJob = {
					job_id: d.job_id || this.syncJob.job_id,
					platform: d.platform || this.syncJob.platform,
					type: d.type || this.syncJob.type,
					status: d.status || this.syncJob.status,
					total: d.total || 0,
					done: d.done || 0,
					failed: d.failed || 0,
					error: d.error || "",
				};
				if (this.syncJob.status === "done" || this.syncJob.status === "failed") {
					this.stopPolling();
				}
			}).catch(err=>{
				// Stop on a hard error (e.g. 404) to avoid an infinite poll loop.
				console.log("poll sync job error", err);
				this.stopPolling();
			});
		},
		closeSyncModal(){
			this.syncModalVisible = false;
			// onSyncModalClose handles timer cleanup.
		},
		onSyncModalClose(){
			this.stopPolling();
		},
		handleViewSyncResult(){
			let platform = this.syncJob.platform || this.syncJobPlatform;
			if (platform === "makro") {
				// Makro offers/products are platform-10 shadow SKUs in productv2;
				// orders open the shared orders page filtered to Makro (id 10).
				if (this.syncJob.type === "product") {
					this.goMakroProductsV2();
				} else {
					this.$router.push({ path: `/backoffice/orders?platform=makro` });
				}
				return;
			}
			if (platform === "amaze") {
				// Amaze products land in productv2 (there is no per-platform
				// product page for it); orders open the shared orders page.
				if (this.syncJob.type === "product") {
					this.$router.push({ path: `/admin/product_platform` });
				} else {
					this.$router.push({ path: `/backoffice/orders?platform=amaze` });
				}
				return;
			}
			if (this.syncJob.type === "product") {
				this.$router.push({ path: `/admin/product/${platform}` });
			} else {
				this.$router.push({ path: `/backoffice/orders?platform=${platform}` });
			}
		}
    },
    beforeDestroy(){
        this.stopPolling();
        this.stopAmazeHealthTimer();
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
</style>
